export const encryptionKey = () =>
  process.env.ENCRYPT_SECRET || "tramsTSVNIybHSIRIoxeBUH2023"
